import { 
    LOADING_LIQUIDACIONES,
    LOADING_ORDENES_LIQUIDACION,
    LOADING_NOVEDADES_LIQUIDACION,
    LOADING_LOGISTICA_LIQUIDACION,
    FETCH_ACCIONES_LIQUIDACIONES,
    FETCH_ESTADOS_LIQUIDACIONES,
    FETCH_RESULTADOS_LIQUIDACIONES,
    FETCH_ACCION_LIQUIDACION_COMBO,
    FETCH_LIQUIDACIONES_BUSQUEDA,
    FETCH_LIQUIDACION_POR_ID,
    FETCH_LIQUIDACION_POR_ID_ORDENES,
    FETCH_LIQUIDACION_POR_ID_NOVEDADES,
    FETCH_LIQUIDACION_POR_ID_LOGISTICA,
    FETCH_ORDENES_PARA_NUEVA_LIQUIDACION,
    FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION,
    LIMPIAR_LIQUIDACIONES_BUSQUEDA
} from './types';

import { 
    getAccionesLiquidaciones,
    getEstadosLiquidaciones,
    getResultadosLiquidaciones,
    getLiquidacionesBusqueda,
    getLiquidacionporid,
    getLiquidacionPorIdOrdenes,
    getLiquidacionPorIdNovedades,
    getLogistica,
    getOrdenesParaNuevaLiquidacion,
    getNovedadesParaNuevaLiquidacion 
} from '../api/axios';


export const fetchAccionesLiquidaciones = () => async dispatch => {
    let array = getAccionesLiquidaciones();
    array.then((value) => {
        dispatch({
            type: FETCH_ACCIONES_LIQUIDACIONES,
            payload: value.listadoNovedadesSubtipo
        });
    })
}

export const fetchEstadosLiquidaciones = () => async dispatch => {
    let array = getEstadosLiquidaciones();
    array.then((value) => {
        dispatch({
            type: FETCH_ESTADOS_LIQUIDACIONES,
            payload: value.listadoEstadosNovedades
        });
    })
}

export const comboAccionLiquidacion = (accion) => dispatch => {
    dispatch({
        type: FETCH_ACCION_LIQUIDACION_COMBO,
        payload: accion
    });
}

export const fetchResultadosLiquidaciones = (request) => async dispatch => {

    dispatch({
        type: LOADING_LIQUIDACIONES,
        payload: true
    });

    let novedades = getResultadosLiquidaciones(request);

    novedades.then(function (value) {

        dispatch({
            type: LOADING_LIQUIDACIONES,
            payload: false
        });

        novedades = value;
        dispatch({
            type: FETCH_RESULTADOS_LIQUIDACIONES,
            payload: value.novedades
        });
    });
}

export const fetchLiquidacionesBusqueda = (request) => async dispatch => {
    
    dispatch({
        type: LOADING_LIQUIDACIONES,
        payload: true
    });

    let array = getLiquidacionesBusqueda(request);
    array.then((value) => {

        dispatch({
            type: LOADING_LIQUIDACIONES,
            payload: false
        });
        
        dispatch({
            type: FETCH_LIQUIDACIONES_BUSQUEDA,
            payload: value.encabezado
        });
    })
}

export const limpiarLiquidacionesBusqueda = () => dispatch => {

    dispatch({
        type: LIMPIAR_LIQUIDACIONES_BUSQUEDA,
        payload:  []
        
    });
}

export const fetchLiquidacionporid = (request) => async dispatch => {

    let array = getLiquidacionporid(request);
    array.then((value) => {
        dispatch({
            type: FETCH_LIQUIDACION_POR_ID,
            payload: value.encabezadoLiquidacion[0]
        });
    })
}

export const fetchLiquidacionporidOrdenes = (request) => async dispatch => {

    dispatch({
        type: LOADING_ORDENES_LIQUIDACION,
        payload: true
    });

    let array = getLiquidacionPorIdOrdenes(request);
    array.then((value) => {

        dispatch({
            type: LOADING_ORDENES_LIQUIDACION,
            payload: false
        });

        dispatch({
            type: FETCH_LIQUIDACION_POR_ID_ORDENES,
            payload: value.ordenes
        });
    })
}

export const fetchLiquidacionporidNovedades = (request) => async dispatch => {

    dispatch({
        type: LOADING_NOVEDADES_LIQUIDACION,
        payload: true
    });

    let array = getLiquidacionPorIdNovedades(request);
    array.then((value) => {
        dispatch({
            type: FETCH_LIQUIDACION_POR_ID_NOVEDADES,
            payload: value.novedadesDeLiquidacion
        });

        dispatch({
            type: LOADING_NOVEDADES_LIQUIDACION,
            payload: false
        });
    })
}

export const fetchLiquidacionporidLogistica = (request) => async dispatch => {

    // el metodo deberia admitir solo un int
    let requestUpdate = { idLiquidacion: [request.idLiquidacion] }

    dispatch({
        type: LOADING_LOGISTICA_LIQUIDACION,
        payload: true
    });

    let array = getLogistica(requestUpdate);
    array.then((value) => {

        dispatch({
            type: FETCH_LIQUIDACION_POR_ID_LOGISTICA,
            payload: value.datosFee
        });

        dispatch({
            type: LOADING_LOGISTICA_LIQUIDACION,
            payload: false
        });
    })
}

export const fetchOrdenesParaNuevaLiquidacion = (request) => async dispatch => {

    dispatch({
        type: LOADING_ORDENES_LIQUIDACION,
        payload: true
    });

    let res = getOrdenesParaNuevaLiquidacion(request);

    res.then((ordenes) => {

        dispatch({
            type: FETCH_ORDENES_PARA_NUEVA_LIQUIDACION,
            payload: ordenes.ordenesAptasParaLiquidar
        });

        dispatch({
            type: LOADING_ORDENES_LIQUIDACION,
            payload: false
        });
    });
}

export const fetchNovedadesParaNuevaLiquidacion = (request) => async dispatch => {

    dispatch({
        type: LOADING_NOVEDADES_LIQUIDACION,
        payload: true
    });

    let res = getNovedadesParaNuevaLiquidacion(request);
    res.then((liquidacion) => {

        dispatch({
            type: FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION,
            payload: liquidacion.novedades
        });

        dispatch({
            type: LOADING_NOVEDADES_LIQUIDACION,
            payload: false
        });
    })
}